module.exports = __webpack_public_path__ + "static/img/Simple-Line-Icons.00ce23c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Simple-Line-Icons.svg
// module id = T3uT
// module chunks = 1